import request from "./request.js";

// 登录
export let login = data => {
  return request("/user/account/login", data);
};

// 退出
export let logout = data => {
  return request("/user/account/logout", data);
};

// 发送手机验证码
export let sendSmsCode = data => {
  return request("/user/account/sendSmsCode", data);
};

// 发送邮箱验证码
export let sendEmailCode = data => {
  return request("/user/account/emailCode/send", data);
};

// 通过手机短信验证码注册
export let regUserByMobileNO = data => {
  return request("/user/account/regUserByMobileNO", data);
};

// 通过邮箱注册
export let regUserByEmail = data => {
  return request("/user/account/regUserByEmail", data);
};

// 手机找回密码
export let modifyPwdByMobile = data => {
  return request("/user/account/modifyPwdByMobile", data);
};

// 邮箱找回密码
export let modifyPwdByEmail = data => {
  return request("/user/account/modifyPwdByEmail", data);
};

// 获取网易云token
export let getAccessToken = data => {
  return request("/user/yun163/getAccessToken", data);
};
